import { MathX } from "../math/MathX";
import { MidiKey } from "./midi/MidiKey";
import { MusicNote } from "./music/MusicNote";

export class AudioMath
{
  static readonly semitonePitch = Math.pow( 2, 1/12 );
  static readonly a4_440_midiKey = 69;

  static beatsToSeconds( beats:number, bpm:number )
  {
    return beats * 60 / bpm;
  }

  static secondsToBeats( seconds:number, bpm:number )
  {
    return seconds / ( 60 / bpm );
  }

  static keyNames = [ "c", "c#", "d", "d#", "e", "f", "f#", "g", "g#", "a", "a#", "b" ];

  static midiKeyToKeyName( midiKey:number )
  {
    return AudioMath.keyNames[ midiKey % 12 ];
  }

  static midiKeyToOctave( midiKey:number )
  {
    let octave = Math.floor( midiKey / 12 ) - 2;
    return octave;
  }

  static midiKeyToFrequency( midiKey:number )
  {
    let semitonesOffset = midiKey - AudioMath.a4_440_midiKey;

    return 440 * Math.pow( AudioMath.semitonePitch, semitonesOffset );
  }

  static midiKeyToKeyInfo( midiKey:number )
  {
    return this.midiKeyToKeyName( midiKey ) + "" + this.midiKeyToOctave( midiKey );
  }

  static isSharpNote( midiKey:number ):boolean
  {
    let keyName = AudioMath.midiKeyToKeyName( midiKey );
    return keyName[ keyName.length - 1 ] === "#";
  }

  static keyInfoToMidiKey( keyInfo:string )
  {
    let regex = /\-?\d+$/
    
    if ( ! regex.test( keyInfo ) )
    {
      return 0;
    }

    let octave = parseInt( regex.exec( keyInfo )[ 0 ] );

    let key = keyInfo.replace( regex, "" );
    
    if ( key == "h" )
    {
      key = "b";
    }

    let keyOffset = this.keyNames.indexOf( key.toLowerCase() );

    return ( octave + 2 ) * 12 + keyOffset;
        
  }

  static decibelToAmplitude( db:number )
  {
    return Math.pow( 10, db / 20.0 ) ;  
  }

  static amplitudeToDecibel( amplitude:number )
  {
    return 20 * MathX.log( amplitude, 10 );      
  }

  static minMidi( a:MidiKey, b:MidiKey )
  {
    if ( a.pitch <= b.pitch )
    {
      return a;
    }

    return b;
  }

  static maxMidi( a:MidiKey, b:MidiKey )
  {
    if ( a.pitch > b.pitch )
    {
      return a;
    }

    return b;
  }

  static minNote( a:MusicNote, b:MusicNote )
  {
    if ( a.midiPitch <= b.midiPitch )
    {
      return a;
    }

    return b;
  }

  static maxNote( a:MusicNote, b:MusicNote )
  {
    if ( a.midiPitch > b.midiPitch )
    {
      return a;
    }

    return b;
  }
}